export default __webpack_public_path__ + "23138144e4f90f57b692b5efb139ff94.png";